import React from 'react';
import Grid from '@material-ui/core/Grid';
import OverviewDescription from './TitleAndDescription';
import WhatYouWillLearn from './WhatYouWillLearn';
import Prerequisites from './Prerequsites';

export default function Overview ({ classes, data }) {
  return <Grid container spacing={2}>
    <Grid item xs={12}>
      <OverviewDescription descriptions={data.descriptions}/>
    </Grid>
    <Grid item xs={12}>
      <WhatYouWillLearn label={'What you will learn'} items={data.learn}/>
    </Grid>
    {data.outcome && <Grid item xs={12}>
      <WhatYouWillLearn label={'Skills you will acquire'} items={data.outcome}/>
    </Grid>}
    <Grid item xs={12}>
      <Prerequisites items={data.preReq}/>
    </Grid>
  </Grid>
};